import confetti from "canvas-confetti";

// Subtle chime via Web Audio API — two soft notes, gentle envelope
function playChime() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const now = ctx.currentTime;
    const master = ctx.createGain();
    master.gain.value = 0.0001;
    master.connect(ctx.destination);
    master.gain.exponentialRampToValueAtTime(0.15, now + 0.02);
    master.gain.exponentialRampToValueAtTime(0.0001, now + 1.2);

    const notes = [880, 1318.5]; // A5, E6
    notes.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      g.gain.value = 0.0001;
      osc.connect(g);
      g.connect(master);
      const start = now + i * 0.12;
      g.gain.exponentialRampToValueAtTime(0.8, start + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, start + 0.9);
      osc.start(start);
      osc.stop(start + 1.0);
    });
    setTimeout(() => ctx.close().catch(() => {}), 1500);
  } catch { /* ignore audio issues */ }
}

// Elegant gold/emerald confetti burst — restrained, matches VEXIS palette
export function celebrateWin({ intensity = 1 } = {}) {
  const colors = ["#E2B96A", "#F0CF85", "#10B981", "#F8FAFC"];
  const defaults = { colors, ticks: 200, gravity: 0.9, scalar: 0.9, disableForReducedMotion: true };

  confetti({
    ...defaults,
    particleCount: Math.round(60 * intensity),
    spread: 60,
    startVelocity: 45,
    origin: { x: 0.15, y: 0.85 },
    angle: 60,
  });
  confetti({
    ...defaults,
    particleCount: Math.round(60 * intensity),
    spread: 60,
    startVelocity: 45,
    origin: { x: 0.85, y: 0.85 },
    angle: 120,
  });
  setTimeout(() => {
    confetti({
      ...defaults,
      particleCount: Math.round(30 * intensity),
      spread: 120,
      startVelocity: 25,
      origin: { x: 0.5, y: 0.4 },
      scalar: 0.7,
    });
  }, 180);

  playChime();
}

// Convenience: only fires when the payout beats 2x the wager
export function maybeCelebrate({ payout, wager }) {
  if (!payout || !wager) return false;
  const ratio = payout / wager;
  if (ratio < 2) return false;
  celebrateWin({ intensity: Math.min(1.6, 0.8 + (ratio - 2) * 0.3) });
  return true;
}
